// MOVA public website behaviour: header menu, reveal-on-scroll, billing toggle,
// signup form (validation + API call) and the login page brand panel.
(function () {
	"use strict";

	var REDUCE = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
	if (!REDUCE && "IntersectionObserver" in window) document.documentElement.classList.add("mv-js");

	function ready(fn) {
		if (document.readyState !== "loading") fn();
		else document.addEventListener("DOMContentLoaded", fn);
	}
	function icon(name, cls) {
		var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		svg.setAttribute("class", cls || "mv-icon");
		svg.setAttribute("aria-hidden", "true");
		var use = document.createElementNS("http://www.w3.org/2000/svg", "use");
		use.setAttribute("href", "#icon-" + name);
		svg.appendChild(use);
		return svg;
	}

	ready(function () {
		setup_header();
		setup_reveal();
		setup_billing();
		setup_login();
		var form = document.getElementById("mv-signup-form");
		if (form) setup_signup(form);
		// frappe's login page links to its own #signup form; send people to MOVA's signup instead
		document.querySelectorAll('a[href="#signup"]').forEach(function (a) {
			a.setAttribute("href", "/signup");
		});
	});

	// --- header ---------------------------------------------------------------
	function setup_header() {
		var header = document.querySelector(".mv-header");
		if (!header) return;
		var toggle = header.querySelector(".mv-header__toggle");
		if (!toggle) return;
		function set(open) {
			header.classList.toggle("is-open", open);
			toggle.setAttribute("aria-expanded", open ? "true" : "false");
		}
		toggle.addEventListener("click", function () {
			set(!header.classList.contains("is-open"));
		});
		header.querySelectorAll(".mv-header__nav a").forEach(function (a) {
			a.addEventListener("click", function () {
				set(false);
			});
		});
		document.addEventListener("keydown", function (e) {
			if (e.key === "Escape" && header.classList.contains("is-open")) {
				set(false);
				toggle.focus();
			}
		});
		document.addEventListener("click", function (e) {
			if (header.classList.contains("is-open") && !header.contains(e.target)) set(false);
		});
		window.addEventListener("resize", function () {
			if (window.innerWidth >= 900) set(false);
		});
	}

	// --- reveal on scroll (opacity/transform only; disabled with reduced motion)
	function setup_reveal() {
		var els = document.querySelectorAll(".mv-reveal");
		if (!els.length) return;
		if (REDUCE || !("IntersectionObserver" in window)) {
			document.documentElement.classList.remove("mv-js");
			document.documentElement.classList.add("mv-no-reveal");
			return;
		}
		var io = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (en) {
					if (en.isIntersecting) {
						en.target.classList.add("is-in");
						io.unobserve(en.target);
					}
				});
			},
			{ threshold: 0.08, rootMargin: "0px 0px -6% 0px" }
		);
		els.forEach(function (el) {
			io.observe(el);
		});
	}

	// --- monthly / yearly billing toggle (pricing page) -------------------------
	function setup_billing() {
		var wrap = document.querySelector(".mv-billing");
		if (!wrap) return;
		var buttons = wrap.querySelectorAll("button[data-billing]");
		function apply(mode) {
			buttons.forEach(function (b) {
				b.setAttribute("aria-pressed", b.dataset.billing === mode ? "true" : "false");
			});
			document.querySelectorAll("[data-monthly][data-yearly]").forEach(function (el) {
				el.textContent = el.dataset[mode];
			});
			document.querySelectorAll("[data-only]").forEach(function (el) {
				el.hidden = el.dataset.only !== mode;
			});
		}
		buttons.forEach(function (b) {
			b.addEventListener("click", function () {
				apply(b.dataset.billing);
			});
		});
		apply(wrap.dataset.default || "monthly");
	}

	// --- login page: brand panel + back link ---------------------------------------
	function setup_login() {
		var login = document.querySelector("section.for-login");
		if (!login || document.querySelector(".mv-login-brand")) return;
		// Frappe's translator when the page has one, so the panel is not the only English on a
		// translated site
		var t = window.__ || (window.frappe && window.frappe._) || function (s) { return s; };
		var aside = document.createElement("aside");
		aside.className = "mv-login-brand";
		aside.innerHTML =
			'<a class="mv-login-brand__logo" href="/landing"><img src="/assets/mova/images/mova-logo-dark.svg" alt="MOVA ERP" height="30"></a>' +
			'<div class="mv-login-brand__body">' +
			'<p class="mv-login-brand__eyebrow">' + t("Welcome back") + "</p>" +
			'<h1 class="mv-login-brand__title">' + t("The ERP for") + " <em>" + t("travel businesses.") + "</em></h1>" +
			'<p class="mv-login-brand__text">' + t("Bookings, tickets, hotels, visas, packages and agents in one workspace, with real accounting underneath.") + "</p>" +
			"</div>" +
			'<ul class="mv-login-brand__foot"><li>' + t("Built for travel agencies") + "</li><li>" + t("Multi-company") + "</li><li>" + t("Human-approved AI") + "</li></ul>";
		document.body.insertBefore(aside, document.body.firstChild);

		// one verb for the same action: the heading and the button both say "Sign in"
		var h4 = login.querySelector(".page-card-head h4");
		if (h4 && /^sign in$/i.test(h4.textContent.trim())) h4.textContent = t("Sign in");
		var submit = login.querySelector(".btn-login");
		if (submit && /^(login|sign in)$/i.test(submit.textContent.trim())) submit.textContent = t("Sign in");
		Array.prototype.forEach.call(login.querySelectorAll("button, .btn"), function (el) {
			if (/^login with email link$/i.test(el.textContent.trim())) el.textContent = t("Sign in with an email link");
		});
		var card = login.querySelector(".page-card");
		if (card && !card.querySelector(".mv-login-back")) {
			var back = document.createElement("a");
			back.className = "mv-login-back";
			back.href = "/landing";
			back.appendChild(icon("arrow-left", "mv-icon mv-icon--sm"));
			back.appendChild(document.createTextNode(t("Back to the website")));
			card.appendChild(back);
		}
	}

	// --- signup ------------------------------------------------------------------
	function setup_signup(form) {
		var submit = document.getElementById("mv-signup-submit");
		var alert = document.getElementById("mv-signup-alert");
		var alertText = alert && alert.querySelector("span");
		var done = document.getElementById("mv-signup-done");
		var country = form.querySelector('select[name="country"]');
		var currency = form.querySelector('input[name="currency"]');
		var currencyHint = document.getElementById("mv-currency-hint");
		var fallbackCurrency = (currency && currency.dataset.fallback) || "USD";
		var touched = {};

		var validators = {
			full_name: function (v) {
				if (!v.trim()) return "Enter your full name.";
				return "";
			},
			email: function (v) {
				v = v.trim();
				if (!v) return "Enter your work email.";
				if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) return "That doesn't look like a valid email address.";
				return "";
			},
			password: function (v) {
				if (!v) return "Choose a password.";
				if (v.length < 8) return "Use at least 8 characters.";
				return "";
			},
			company_name: function (v) {
				if (!v.trim()) return "Enter your company name.";
				return "";
			},
			country: function (v) {
				if (!v) return "Choose your country.";
				return "";
			},
		};

		function field_wrap(input) {
			return input.closest(".mv-field");
		}
		function set_error(input, msg) {
			var wrap = field_wrap(input);
			if (!wrap) return;
			var err = wrap.querySelector(".mv-field__error span");
			wrap.classList.toggle("is-invalid", !!msg);
			wrap.classList.toggle("is-valid", !msg && !!input.value);
			input.setAttribute("aria-invalid", msg ? "true" : "false");
			if (err) err.textContent = msg || "";
		}
		function validate(input) {
			var fn = validators[input.name];
			if (!fn) return true;
			var msg = fn(input.value);
			set_error(input, msg);
			return !msg;
		}
		function validate_terms() {
			var terms = form.querySelector('input[name="accept_terms"]');
			var ok = terms.checked;
			// colour alone is not a message: say what is wrong and mark the control for screen readers
			terms.closest(".mv-check").classList.toggle("is-invalid", !ok);
			terms.setAttribute("aria-invalid", ok ? "false" : "true");
			var note = document.getElementById("mv-terms-error");
			if (note) note.classList.toggle("mv-hidden", ok);
			return ok;
		}
		function show_alert(msg) {
			if (!alert) return;
			alertText.textContent = msg;
			alert.classList.remove("mv-hidden");
			alert.setAttribute("tabindex", "-1");
			alert.focus({ preventScroll: false });
		}
		function hide_alert() {
			if (alert) alert.classList.add("mv-hidden");
		}

		Object.keys(validators).forEach(function (name) {
			var input = form.querySelector('[name="' + name + '"]');
			if (!input) return;
			input.addEventListener("blur", function () {
				touched[name] = true;
				validate(input);
			});
			input.addEventListener("input", function () {
				if (touched[name] || field_wrap(input).classList.contains("is-invalid")) validate(input);
			});
			input.addEventListener("change", function () {
				if (touched[name]) validate(input);
			});
		});

		// derive the base currency from the country; the company can change it later
		function sync_currency() {
			if (!country || !currency) return;
			var opt = country.options[country.selectedIndex];
			var cur = (opt && opt.dataset.currency) || fallbackCurrency;
			currency.value = cur;
			if (currencyHint) currencyHint.textContent = "Base currency " + cur + " — you can change it in company settings.";
		}
		if (country) {
			country.addEventListener("change", sync_currency);
			sync_currency();
		}

		// password visibility
		var pwToggle = form.querySelector(".mv-input-btn[data-toggle-password]");
		if (pwToggle) {
			pwToggle.addEventListener("click", function () {
				var input = form.querySelector('input[name="password"]');
				var show = input.type === "password";
				input.type = show ? "text" : "password";
				pwToggle.setAttribute("aria-label", show ? "Hide password" : "Show password");
				pwToggle.setAttribute("aria-pressed", show ? "true" : "false");
				input.focus();
			});
		}

		form.querySelector('input[name="accept_terms"]').addEventListener("change", function () {
			if (this.checked) {
				this.closest(".mv-check").classList.remove("is-invalid");
				this.setAttribute("aria-invalid", "false");
				var note = document.getElementById("mv-terms-error");
				if (note) note.classList.add("mv-hidden");
			}
		});

		form.addEventListener("submit", function (e) {
			e.preventDefault();
			hide_alert();
			var firstInvalid = null;
			Object.keys(validators).forEach(function (name) {
				var input = form.querySelector('[name="' + name + '"]');
				if (!input) return;
				touched[name] = true;
				if (!validate(input) && !firstInvalid) firstInvalid = input;
			});
			var termsOk = validate_terms();
			if (firstInvalid) {
				firstInvalid.focus();
				return;
			}
			if (!termsOk) {
				form.querySelector('input[name="accept_terms"]').focus();
				return;
			}
			var data = new FormData(form);
			var payload = {
				full_name: data.get("full_name").trim(),
				email: data.get("email").trim(),
				password: data.get("password"),
				company_name: data.get("company_name").trim(),
				country: data.get("country"),
				currency: data.get("currency") || fallbackCurrency,
				accept_terms: 1,
				website: data.get("website") || "",
			};
			submit.classList.add("is-loading");
			submit.setAttribute("aria-busy", "true");
			submit.disabled = true;

			// plain fetch: keeps every error inline instead of Frappe's generic message modal
			fetch("/api/method/mova.api.signup.sign_up", {
				method: "POST",
				credentials: "same-origin",
				headers: { "Content-Type": "application/json", Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
				body: JSON.stringify(payload),
			})
				.then(function (resp) {
					// a proxy or gateway can answer with HTML; parsing that must not surface as a JS error
					return resp.json().then(
						function (body) {
							return { ok: resp.ok, body: body || {} };
						},
						function () {
							return { ok: false, body: { message: resp.status === 429 ? "Too many attempts. Please wait a little and try again." : "The server could not be reached. Please try again." } };
						}
					);
				})
				.then(function (r) {
					if (r.ok && r.body.message) {
						form.classList.add("mv-hidden");
						var head = document.getElementById("mv-signup-head");
						if (head) head.classList.add("mv-hidden");
						var next = document.getElementById("mv-signup-next");
						if (next) next.classList.add("mv-hidden");
						done.classList.remove("mv-hidden");
						window.scrollTo({ top: 0, behavior: REDUCE ? "auto" : "smooth" });
						done.focus({ preventScroll: true });
						// when the instance asks for email confirmation the account waits, so no redirect
						if (r.body.message.verify_email) {
							var title = done.querySelector("h2");
							var copy = done.querySelector("p");
							var bar = done.querySelector(".mv-progress");
							if (title) title.textContent = "Check your inbox";
							if (copy) copy.textContent = "We sent a confirmation link to " + r.body.message.verify_email + ". Open it to finish setting up your workspace.";
							if (bar) bar.remove();
							return;
						}
						setTimeout(function () {
							window.location.href = r.body.message.redirect_to || "/desk";
						}, REDUCE ? 400 : 1100);
						return;
					}
					throw r.body;
				})
				.catch(function (body) {
					submit.classList.remove("is-loading");
					submit.removeAttribute("aria-busy");
					submit.disabled = false;
					var msg = "Something went wrong. Please try again.";
					try {
						var msgs = body && body._server_messages ? JSON.parse(body._server_messages) : [];
						// the last message is the one that stopped the request
						if (msgs.length) msg = JSON.parse(msgs[msgs.length - 1]).message || msg;
						else if (body && body.message && typeof body.message === "string") msg = body.message;
						else if (body && body.exception && /Rate ?limit|Too many/i.test(body.exception)) msg = "Too many attempts. Please wait a little and try again.";
					} catch (err) {
						/* keep generic */
					}
					msg = String(msg).replace(/<[^>]+>/g, "");
					// point known messages at the field they concern
					var lower = msg.toLowerCase();
					if (lower.indexOf("email") !== -1 && lower.indexOf("exists") !== -1) {
						set_error(form.querySelector('input[name="email"]'), msg);
						form.querySelector('input[name="email"]').focus();
					} else if (lower.indexOf("company") !== -1 && lower.indexOf("exists") !== -1) {
						set_error(form.querySelector('input[name="company_name"]'), msg);
						form.querySelector('input[name="company_name"]').focus();
					} else if (lower.indexOf("password") !== -1) {
						// the server's password policy verdict belongs next to the field, with its suggestions
						set_error(form.querySelector('input[name="password"]'), msg.replace(/^invalid password:\s*/i, ""));
						form.querySelector('input[name="password"]').focus();
					} else if (lower.indexOf("work email") !== -1 || lower.indexOf("not accepted") !== -1) {
						set_error(form.querySelector('input[name="email"]'), msg);
						form.querySelector('input[name="email"]').focus();
					} else {
						show_alert(msg);
					}
				});
		});
	}
})();
